// @flow
import React from 'react';
import classnames from 'classnames';

export type AddressProps = {
  additionalInformation1?: string,
  additionalInformation2?: string,
  addOn?: string,
  className?: string,
  country?: string,
  city?: string,
  town?: string,
  stateOrDistrict?: string,
  streetNumber?: string,
  streetName?: string,
  zipCode?: string,
};

function toLine(...values) {
  return values.filter(Boolean).join(' ');
}

function AddressLine({ children }) {
  return children ? (
    <li className="leading-normal text-base text-gray-darker">{children}</li>
  ) : null;
}

export function Address(props: AddressProps) {
  const {
    additionalInformation1,
    additionalInformation2,
    addOn,
    city,
    className,
    country,
    stateOrDistrict,
    streetNumber,
    streetName,
    town,
    zipCode,
  } = props;

  return (
    <ul className={classnames(className, 'reset-list')}>
      <AddressLine>{toLine(streetNumber, streetName)}</AddressLine>
      <AddressLine>{toLine(additionalInformation1)}</AddressLine>
      <AddressLine>{toLine(additionalInformation2)}</AddressLine>
      <AddressLine>{toLine(addOn, city)}</AddressLine>
      <AddressLine>{toLine(town, zipCode)}</AddressLine>
      <AddressLine>{toLine(stateOrDistrict, country)}</AddressLine>
    </ul>
  );
}
